import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../features/component/login/auth.service';

@Component({
  selector: 'app-base',
  standalone: false,
  templateUrl: './base.html',
  styleUrl: './base.scss'
})
export class Base implements OnInit {
  
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    this.checkAuthentication();
  }

  private checkAuthentication(): void {
    const authToken = localStorage.getItem('auth_token');
    
    if (!authToken) {
      // No token found, logout and redirect to login
      this.authService.logout();
      this.router.navigate(['/login']);
    }
  }
}
